// <head> metadata for AboutPage (https://www.dbos.dev/about).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'DBOS - Effortless Open Source Durable Workflow Orchestration',
    },
    {
      name: 'description',
      content:
        'DBOS is rethinking how software and AI agents are built and made fault tolerant. Meet our team and investors, and see open roles.',
    },
    {
      property: 'og:title',
      content: 'DBOS - Effortless Open Source Durable Workflow Orchestration',
    },
    {
      property: 'og:description',
      content:
        'DBOS is rethinking how software and AI agents are built and made fault tolerant. Meet our team and investors, and see open roles.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      name: 'twitter:title',
      content: 'DBOS - Effortless Open Source Durable Workflow Orchestration',
    },
    {
      name: 'twitter:description',
      content:
        'DBOS is rethinking how software and AI agents are built and made fault tolerant. Meet our team and investors, and see open roles.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/about',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
